import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SearchContext } from './SearchContext';
export function SearchProvider(props) {
    const [searchValue, setSearchValue] = React.useState('');
    return (_jsx(SearchContext.Provider, Object.assign({ value: { searchValue, setSearchValue } }, { children: props.children })));
}
